export default __webpack_public_path__ + "static/media/Image2_Tablet.61c92634.png";